import { ConsumptionTypeDto } from '@eneco/dc-be/client';
import { getTokens } from '@eneco/sparky/stitches';

const { colors } = getTokens();

export const electricity = colors.graphsElectricityPrimary.toString();
export const electricitySecondary = colors.graphsElectricitySecondary.toString();
export const gas = colors.graphsGasPrimary.toString();
export const peakValues = colors.iconOnBackgroundVarTwo.toString();
export const injection = colors.graphsSolarPrimary.toString();
export const injectionSecondary = colors.graphsSolarSecondary.toString();

/**
 * Returns the appropriate color range for a given consumption type
 */
export const getColorRange = (consumptionType: ConsumptionTypeDto, hasSecondaryTariff: boolean) => {
  const colorMap = {
    Total: [gas, electricity, injection],
    PeakValues: [peakValues],
    Injection: hasSecondaryTariff ? [injection, injectionSecondary] : [injection],
    Gas: [gas],
    Electricity: hasSecondaryTariff ? [electricitySecondary, electricity, injection] : [electricity, injection],
  };

  return colorMap[consumptionType] || [gas, electricity, injection];
};
